




















































































































import { Component } from "vue-property-decorator";
import NubiiSidebarComponent from "@/app/views/nubii/components/sidebar/sidebar.component.vue";
import CallComponent from "@/app/components/call/call.component.vue";
import MainComponent from "@/app/views/nubii/components/main/main.component.vue";
import ManageSpaceComponent from "@/app/components/manageSpace/manageSpace.component.vue";
import { mixins } from "vue-class-component";
import ModalsView from "@/app/views/modals/modals.component.vue";
import Loader from "@/resources/mixins/loader/loader";
import ChatComponent from "@/app/components/chat/chat.component.vue";
import NetworkConnection from "@/resources/mixins/notifications/networkConnection";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
import { i18n } from "@/resources/locales";
import ErrorController from "@/resources/mixins/errorController/errorController";
import BackGroundHelper from "@/helpers/background/background";
import TitleMixin from "@/resources/mixins/titleController/titleMixin";
import CameraOptionsComponent from "@/app/views/nubii/components/graphicClientOptions/cameraOptions.component.vue";
import LoadApp from "@/resources/mixins/loadApp/loadApp";
import RecordOptionsComponent from "@/app/components/recordOptions/recordOptions.component.vue";
import UserListComponent from "@/app/views/nubii/components/sidebar/userList/userList.component.vue";
import { NUBII_SIDEBAR_OPTIONS } from "@/resources/constants/sidebarMenu";
import ConfigMenuComponent from "@/app/views/nubii/components/sidebar/configMenu/configMenu.component.vue";
import ChatMenuComponent from "@/app/views/nubii/components/sidebar/chatMenu/chatMenu.component.vue";
import NextMaintenanceComponent from "@/app/views/nubii/components/nextMaintenance/nextMaintenance.component.vue";
import SuperSpacesListComponent from "@/app/views/nubii/components/sidebar/superSpacesList/superSpacesList.component.vue";
import CityComponent from "./components/city/city.component.vue";
import FloatingMenuComponent from "@/app/views/nubii/components/floatingMenu/floatingMenu.component.vue";
import ConfigUtilitiesComponent from "@/app/views/nubii/components/sidebar/configUtilities/configUtilities.component.vue";

declare global {
  interface window {
    graphicClientInitializer: () => void;
  }
}
@Component({
  components: {
    ChatMenuComponent,
    ConfigMenuComponent,
    UserListComponent,
    RecordOptionsComponent,
    CameraOptionsComponent,
    ChatComponent,
    ModalsView,
    ManageSpaceComponent,
    MainComponent,
    CallComponent,
    NubiiSidebarComponent,
    NextMaintenanceComponent,
    SuperSpacesListComponent,
    CityComponent,
    FloatingMenuComponent,
    ConfigUtilitiesComponent,
  },
})
export default class NubiiView extends mixins(
  LoadApp,
  Loader,
  NetworkConnection,
  NotificationEvent,
  ErrorController,
  BackGroundHelper,
  TitleMixin
) {
  NUBII_SIDEBAR_OPTIONS = NUBII_SIDEBAR_OPTIONS;
  constructor() {
    super();
  }
  SUPER_SPACE_ID_CHECK_REGISTER = 1204;
  showViewTest = false;
  city = true;
  countScript = 0;
  retryCountLoadGraphicalClient = 0;
  listScripts = ["./graphic-client/app.js"];
  created(): void {
    this.CheckOperatingSystem();
    if (process.env.VUE_APP_ENVIRONMENT == "PRO")
      console.log("FRONT nubi.city PRO");
    else if (process.env.VUE_APP_ENVIRONMENT == "PRE")
      console.log("FRONT nubi.city PRE");
    const isCity = localStorage.getItem("city");
    if (!isCity)
      localStorage.setItem(
        "city",
        !localStorage.getItem("space_default") ? "ON" : "OFF"
      );

    if (isCity == null) this.city = true;
    else this.city = isCity == "ON" ? true : false;
    this.loadAllScripts();
    this.setNotificationPermissions();
    this.setVideoAndMicSelected();
    this.startLoader(this.$store);
    this.setLoaderText(this.$store, i18n.t("loader.loadingData").toString());
    /*this.$store.dispatch(
      "SystemStore/setShowCameraOptionsAction",
      localStorage.getItem("camera_options") !== "false"
    );*/
    this.showViewTest = false; //process.env.VUE_APP_ENVIRONMENT == "DEV" ? true : false;
    if (window.name !== "nubiTeams") {
      localStorage.removeItem("isTeams");
    }

    let isTeams = localStorage.getItem("isTeams");
    let space_default = localStorage.getItem("space_default");
    let super_space_id_default = localStorage.getItem("super_space_id_default");

    if ((isTeams || super_space_id_default) && !space_default) {
      this.$store.dispatch("SpaceStore/getSpacePaginateAction", {
        id: super_space_id_default,
        callback: (response) => {
          localStorage.removeItem("super_space_id_default");
          this.$store.dispatch(
            "SystemStore/setOpenChangeSpaceModalAction",
            true
          );
        },
        callbackError: (error) => {
          // do nothing
        },
      });
    }
  }

  get sidebarFull(): boolean {
    return this.$store.getters["SidebarStore/getSidebarFull"];
  }
  get openChat(): boolean {
    return this.$store.getters["SidebarStore/getOpenChat"];
  }
  get openCall(): boolean {
    return this.$store.getters["SidebarStore/getOpenCall"];
  }
  get activeMenu(): number {
    return this.$store.getters["SidebarStore/getActiveMenu"];
  }
  get showNextMaintenance(): boolean {
    return this.$store.getters["FloatMenuStore/getShowNextMaintenance"];
  }
  get openNotepadButton(): boolean {
    return this.$store.getters["SystemStore/getOpenNotepadButton"];
  }
  get spaceLocal(): any {
    return this.$store.getters["SpaceStore/getSpace"];
  }
  async loadAllScripts(): Promise<void> {
    // eslint-disable-next-line no-async-promise-executor
    new Promise(async (resolve, reject): Promise<void> => {
      let loadScript = 0;
      loadScript = await this.promiseLoadScript(
        this.listScripts[this.countScript]
      );
      if (process.env.VUE_APP_ENVIRONMENT !== "PRO")
        console.log("loadAllScripts", this.listScripts[this.countScript]);
      if (loadScript == 0) reject(0);
      else resolve(loadScript);
    })
      .then(async (result) => {
        if (process.env.VUE_APP_ENVIRONMENT !== "PRO")
          console.log("loadAllScripts ", result);
        await this.createPusherAction();
      })
      .catch((error) => {
        if (process.env.VUE_APP_ENVIRONMENT !== "PRO")
          console.log("loadAllScripts ", error);
      });
  }
  async promiseLoadScript(url: string): Promise<number> {
    return new Promise<number>(function (resolve, reject) {
      try {
        let script = document.createElement("script");
        script.setAttribute("src", url);
        document.head.appendChild(script);
        script.onload = function () {
          resolve(1);
        };
        script.onerror = function () {
          reject(0);
        };
      } catch (error) {
        reject(0);
      }
    });
  }
  setNotificationPermissions(): void {
    if (
      Notification.permission !== "granted" &&
      Notification.permission !== "denied"
    ) {
      Notification.requestPermission().then((result) => {
        if (result === "granted") {
          const options = {
            body: this.$i18n.t("notifications.permissionsOk.body").toString(),
            image: "https://assets-pro.nubi.city/nubii-us-blue.png",
            icon: "/src/assets/logo/nubii_blue.png",
            silent: false,
          };
          const notification = new Notification(
            this.$i18n.t("notifications.permissionsOk.title").toString(),
            options
          );
          setTimeout(notification.close.bind(notification), 5000);
        }
      });
    }
  }
  setVideoAndMicSelected(): void {
    const videoInput = localStorage.getItem("PREFERRED_VIDEO_INPUT");
    const audioInput = localStorage.getItem("PREFERRED_AUDIO_INPUT");
    const audioOutput = localStorage.getItem("PREFERRED_AUDIO_OUTPUT");
    if (videoInput && audioInput) {
      this.$store.dispatch(
        "MeetingStore/setSelectedAudioInputAction",
        audioInput
      );
      this.$store.dispatch(
        "MeetingStore/setSelectedVideoInputAction",
        videoInput
      );
    }
    if (audioOutput) {
      this.$store.dispatch(
        "MeetingStore/setSelectedAudioOutputAction",
        audioOutput
      );
    }
  }
  CheckOperatingSystem(): void {
    let OSName = "Unknown";
    if (window.navigator.userAgent.indexOf("Windows NT 10.0") != -1)
      OSName = "Windows 10";
    if (window.navigator.userAgent.indexOf("Windows NT 6.3") != -1)
      OSName = "Windows 8.1";
    if (window.navigator.userAgent.indexOf("Windows NT 6.2") != -1)
      OSName = "Windows 8";
    if (window.navigator.userAgent.indexOf("Windows NT 6.1") != -1)
      OSName = "Windows 7";
    if (window.navigator.userAgent.indexOf("Windows NT 6.0") != -1)
      OSName = "Windows Vista";
    if (window.navigator.userAgent.indexOf("Windows NT 5.1") != -1)
      OSName = "Windows XP";
    if (window.navigator.userAgent.indexOf("Windows NT 5.0") != -1)
      OSName = "Windows 2000";
    if (window.navigator.userAgent.indexOf("Mac") != -1) OSName = "Mac/iOS";
    if (window.navigator.userAgent.indexOf("X11") != -1) OSName = "UNIX";
    if (window.navigator.userAgent.indexOf("Linux") != -1) OSName = "Linux";

    localStorage.setItem("OSName", OSName);
  }
  inTheRoom() {
    let room = this.$store.getters["SystemStore/getCurrentRoom"];
    if (room) {
      this.$store.dispatch("GraphicClientStore/inTheSpace", room.id);
    } else console.log("You are not in a room");
  }
  updateWalls(isTransparent: boolean) {
    this.$store.dispatch("GraphicClientStore/wallsUpdateAction", isTransparent);
  }
}
